import { Encoding, MarkTransform, MarkType } from '@mode-vegas/vegas';
import { ChartTypes } from '@mode/shared/contract-common';
import { EncodingHelpers } from '../..';
import { ChartTranslator } from '../chart-translator';
import { addMeasureValuesToSeries, clearTextChannel } from './translator-util';

export class BarTranslator implements ChartTranslator {
  translateHighChartsToMuze(encoding: Encoding, format: Readonly<ChartTypes.ChartFormat>): Encoding {
    encoding = clearTextChannel(encoding);
    if (encoding.marks.channel === '*') {
      return encoding;
    }
    if (format.showValues) {
      encoding = addMeasureValuesToSeries(encoding, 'text');
    }
    encoding = EncodingHelpers.updateMarkOptions(encoding, {
      type: MarkType.Bar,
      showStackSum: true,
      transform: MarkTransform.Stack,
    }).encoding;

    return encoding;
  }

  translateMuzeToHighCharts(encoding: Encoding, format: Readonly<ChartTypes.ChartFormat>): Encoding {
    encoding = clearTextChannel(encoding);
    return encoding;
  }

  formatRequiresEncodingUpdate(
    oldFormat: Readonly<ChartTypes.ChartFormat>,
    newFormat: Readonly<ChartTypes.ChartFormat>
  ): boolean {
    return oldFormat.showValues !== newFormat.showValues;
  }
}
